import SettingsStore from "@/stores/SettingsStore";
import { toast } from "sonner";

export default function toaster(text: string, type: "error" | "success" = "success") {
  const isError = type === "error";
  const showToasts = SettingsStore.getState().displayMessages;
  if (isError) {
    console.error(`🔴 ${text}`);
  } else {
    console.info(`🟢 ${text}`);
  }
  showToasts && toast(text, { duration: 2000, dismissible: true, closeButton: true, richColors: true });
}
